import {LoadingButton} from '@mui/lab';
import {Button} from '@mui/material';

const BaseButton = ({loading, children, ...rest}) => {
  // loadingPosition="start"
  // [LoadingButton] Displaying incorrect warning #31235
  // https://github.com/mui/material-ui/issues/31235
  return loading ? (
    <LoadingButton {...rest} loading>
      <div style={{}}>{children}</div>
    </LoadingButton>
  ) : (
    <Button {...rest}>{children}</Button>
  );
};

export default BaseButton;
